"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/RecipientTable/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Avatar = require('web/components/Avatar');
var _Pagination = require('web/components/Pagination'); var _Pagination2 = _interopRequireDefault(_Pagination);
var _Checkbox = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Checkbox'); var _Checkbox2 = _interopRequireDefault(_Checkbox);

/* Rev 29 Y3: the one recipients table. The shared recipients screen, Add
 * existing and the CSV review all render it; each brings its own rows and
 * behaviour. Rev 31 v2 column order (Q1): select, Patient (pinned), Date of
 * birth, Contact, Tags (the Recipients list only, D-58), Status, Scheduled at and Sent at (only once sending has
 * started, Q3), the variables, then an optional header-only cell (+ Add
 * variable) and an optional actions column. */

// select, Patient, Date of birth, Contact, Status
const FIXED_COLUMNS = 5


























 const SectionContext = _react2.default.createContext(FIXED_COLUMNS); exports.SectionContext = SectionContext

const RecipientTable = ({
  variableHeaders = null,
  variableCount = 0,
  trailingHeader = null,
  hasActions = false,
  hasTimes = true,
  hasTags = false,
  selectAll,
  hasItems,
  emptyState = null,
  emptyClassName,
  isBusy = false,
  page = 0,
  children,
}) => {
  const scrollerRef = _react.useRef(null)
  // The pinned Patient column's edge shows only while scrolled sideways (N3).
  const [isScrolled, setIsScrolled] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, () => {
    if (scrollerRef.current) scrollerRef.current.scrollTop = 0
  }, [page])
  const columnCount = FIXED_COLUMNS + (hasTags ? 1 : 0) + (hasTimes ? 2 : 0) + variableCount + (trailingHeader ? 1 : 0) + (hasActions ? 1 : 0)
  return (
    _react2.default.createElement('div', {
      ref: scrollerRef,
      className: _classBuilder2.default.call(void 0, 
        'campaign--table--wrapper',
        'campaign--table--wrapper--scroll',
        isScrolled && 'campaign--table--wrapper--scrolled',
      ),
      'aria-busy': isBusy || undefined,
      onScroll: e => {
        const scrolled = e.currentTarget.scrollLeft > 0
        setIsScrolled(s => s === scrolled ? s : scrolled)
      }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}

      , _react2.default.createElement('table', { className: "campaign--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
        , _react2.default.createElement('thead', { className: "campaign--table--head campaign--table--head--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
          , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
            , _react2.default.createElement('th', { className: "campaign--table--row-checkbox", 'aria-label': "Toggle selection" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
              , _react2.default.createElement(_Checkbox2.default, {
                isChecked: selectAll.isChecked,
                isMixed: selectAll.isMixed,
                isDisabled: selectAll.isDisabled,
                onChange: selectAll.onChange,
                label: "Select all on this page"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
              )
            )
            , _react2.default.createElement('th', { className: "campaign--table--col-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, "Patient")
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "Date of birth"  )
            , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, "Contact")
            ,  hasTags && _react2.default.createElement('th', { className: "campaign--table--col-tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "Tags") 
            , _react2.default.createElement('th', { className: "campaign--table--row-status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, "Status")
            ,  hasTimes && _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}, "Scheduled at" ) 
            ,  hasTimes && _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Sent at" ) 
            ,  variableHeaders 
            ,  trailingHeader && _react2.default.createElement('th', { className: "campaign--table--col-trailing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}},  trailingHeader ) 
            ,  hasActions && _react2.default.createElement('th', { className: "campaign--table--col-actions", 'aria-label': "Actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}} ) 
          )
        )
        , _react2.default.createElement('tbody', { className: "campaign--table--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}
          , _react2.default.createElement(exports.SectionContext.Provider, { value: columnCount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}
            ,  children 
          )
        )
      )
      ,  !hasItems && _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'campaign--table--empty', emptyClassName), __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}},  emptyState ) 
    )
  )
}

/* A full-width label over a group of rows ("Not added yet · 3"). */
 const RecipientSection = ({ label }) => (
  _react2.default.createElement('tr', { className: "campaign--table--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
    , _react2.default.createElement(exports.SectionContext.Consumer, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}
      ,  columnCount => _react2.default.createElement('td', { colSpan: columnCount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}},  label ) 
    )
  )
); exports.RecipientSection = RecipientSection

/* A full-width note in the rows' place (loading, no matches). */
 const RecipientNote = ({ children, className }) => (
  _react2.default.createElement('tr', { className: _classBuilder2.default.call(void 0, 'campaign--table--note', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
    , _react2.default.createElement(exports.SectionContext.Consumer, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
      ,  columnCount => _react2.default.createElement('td', { colSpan: columnCount, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}},  children ) 
    )
  )
); exports.RecipientNote = RecipientNote

const stopPropagation = (e) => e.stopPropagation()




























 const RecipientRow = ({
  selection = null,
  onClick,
  avatarKey,
  name,
  nameTitle,
  dob,
  contact,
  tags,
  variableCells = null,
  status,
  scheduledAt = null,
  sentAt = null,
  hasTrailingCell = false,
  hasTimes = true,
  actions,
  className,
  rowId,
}) => (
  _react2.default.createElement('tr', {
    className: _classBuilder2.default.call(void 0, 'campaign--table--row', !onClick && 'campaign--table--row--static', className),
    onClick: onClick,
    'data-row-id': rowId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}

    , _react2.default.createElement('td', { className: "campaign--table--row-checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}
      ,  selection && (
        _react2.default.createElement(_Checkbox2.default, {
          isChecked: selection.isSelected,
          onChange: selection.onToggle,
          label: selection.label,
          className: "campaign--table--record-checkbox", __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}}
        )
      )
    )
    , _react2.default.createElement('td', { className: "campaign--table--col-name", title: nameTitle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}
      , _react2.default.createElement('div', { className: "campaign--table--col-name--inner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}
        , _react2.default.createElement(_Avatar.PatientAvatar, { size: 25, noBadge: true, patientKey: avatarKey , __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}} )
        ,  typeof name === 'string'
          ? _react2.default.createElement('span', { className: "campaign--table--col-name--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}},  name )
          : name
        
      )
    )
    , _react2.default.createElement('td', { className: "campaign--table--col-dob", __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 207}},  dob ))
    , _react2.default.createElement('td', { className: "campaign--table--col-contact", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 208}},  contact ))
    ,  tags !== undefined && _react2.default.createElement('td', { className: "campaign--table--col-tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}},  tags ) 
    , _react2.default.createElement('td', { className: "campaign--table--row-status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}},  status )
    ,  hasTimes && _react2.default.createElement('td', { className: "campaign--table--row-scheduled-at", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}},  scheduledAt ) 
    ,  hasTimes && _react2.default.createElement('td', { className: "campaign--table--row-sent-at", __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}},  sentAt ) 
    ,  variableCells 
    ,  hasTrailingCell && _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 214}} ) 
    ,  actions !== undefined && (
      // Review R800-48: the row's own actions (···, ×) and the menu ···
      // portals (React bubbles portal events through this cell) never
      // reach the row's click, which selects it.
      _react2.default.createElement('td', { className: "campaign--table--col-actions", onClick: stopPropagation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}},  actions )
    )
  )
); exports.RecipientRow = RecipientRow

/* The pager under (or beside) the table. Nothing for a single page. */
 const RecipientPager




 = ({ page, pageCount, onPage, className }) => pageCount > 1
  ? (
      _react2.default.createElement(_Pagination2.default, {
        className: _classBuilder2.default.call(void 0, 'campaign--table--pagination', className),
        minPage: 0,
        currentPage: page,
        maxPage: pageCount - 1,
        gotoPage: onPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}
      )
    )
  : null; exports.RecipientPager = RecipientPager

exports. default = RecipientTable
